import { toast } from 'components';
import { lacleStore } from 'store';
import { MatchingApi } from './api';

const MatchingActioner = {
  list: (campaign, site) => {
    return MatchingApi.getList(campaign, site)
      .then(res => res)
      .catch(err => {
        const messages = lacleStore.getState().I18n.messages.toast.error;
        toast.error(messages.unableToRetrieveMatchingList);
        throw err;
      });
  },
  doneList: (campaign, site) => {
    return MatchingApi.getDoneList(campaign, site)
      .then(res => res)
      .catch(err => {
        const messages = lacleStore.getState().I18n.messages.toast.error;
        toast.error(messages.unableToRetrieveMatchingList);
        throw err;
      });
  },
  studentList: (campaign, site, id) => {
    return MatchingApi.getStudentList(campaign, site, id)
      .then(res => res)
      .catch(err => {
        const messages = lacleStore.getState().I18n.messages.toast.error;
        toast.error(messages.unableToRetrieveMatchingList);
        throw err;
      });
  },
  volunteerList: (campaign, site, id) => {
    return MatchingApi.getVolunteerList(campaign, site, id)
      .then(res => res)
      .catch(err => {
        const messages = lacleStore.getState().I18n.messages.toast.error;
        toast.error(messages.unableToRetrieveMatchingList);
        throw err;
      });
  },
  get: id => {
    return MatchingApi.getSpecific(id)
      .then(res => res)
      .catch(err => {
        const messages = lacleStore.getState().I18n.messages.toast.error;
        toast.error(messages.unableToRetrieveMatchingInfos);
        throw err;
      });
  },
  create: (id, fields) => {
    return MatchingApi.create(id, fields)
      .then(() => {
        const messages = lacleStore.getState().I18n.messages.toast.success;
        toast.success(messages.successFullyCreated);
      })
      .catch(err => {
        const messages = lacleStore.getState().I18n.messages.toast.error;
        const msg = err.description ? err.description : messages.errorOccured;
        toast.error(msg);

        throw err;
      });
  },
  update: (id, fields) => {
    return MatchingApi.update(id, fields)
      .then(() => {
        const messages = lacleStore.getState().I18n.messages.toast.success;
        toast.success(messages.successFullyEdited);
      })
      .catch(err => {
        const messages = lacleStore.getState().I18n.messages.toast.error;
        const msg = err.description ? err.description : messages.errorOccured;
        toast.error(msg);

        throw err;
      });
  },
  delete: id => {
    return MatchingApi.delete(id)
      .then(() => {
        const messages = lacleStore.getState().I18n.messages.toast.success;
        toast.success(messages.successFullyDeleted);
      })
      .catch(err => {
        const messages = lacleStore.getState().I18n.messages.toast.error;
        const msg = err.description ? err.description : messages.errorOccured;
        toast.error(msg);

        throw err;
      });
  },
  getStudentMatchingByUuid: (uuid) => {
    return MatchingApi.getStudentMatchingByUuid(uuid)
      .then(res => res)
      .catch(err => {
        const messages = lacleStore.getState().I18n.messages.toast.error;
        toast.error(messages.unableToRetrieveMatchingList);
        throw err;
      });
  },
  getVolunteerMatchingByUuid: (uuid) => {
    return MatchingApi.getVolunteerMatchingByUuid(uuid)
      .then(res => res)
      .catch(err => {
        const messages = lacleStore.getState().I18n.messages.toast.error;
        toast.error(messages.unableToRetrieveMatchingList);
        throw err;
      });
  }
};

export { MatchingActioner };
